<template>
  <slot />
</template>

<script>
export default {
  name: 'BlankLayout'
}
</script>
